import { To } from "react-router";
import Routing from "../routing";
import BreadcrumbsItem, { BreadcrumbsItemProps } from "./breadcrumbsItem";

export interface BreadcrumbsLinkProps extends BreadcrumbsItemProps {
  to: To;
}

export default function BreadcrumbsLink(props: Readonly<BreadcrumbsLinkProps>) {
  const { to, ...rest } = props;
  return (
    <Routing to={to}>
      <BreadcrumbsItem
        {...rest}
        className="hover:bg-slate-100 transition-all"
      />
    </Routing>
  );
}
